import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './Components/Home/Home'
import Admin from './Components/Admin/Admin';
import AuthRoute from './context/AuthRoute';

function App() {

  return (
    <>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/admin' element={<AuthRoute><Admin /> </AuthRoute>} />
      </Routes>

    </>
  );
}

export default App;
